import {
  Add as AddIcon,
  Description as DescriptionIcon,
  VideoLibrary as VideoLibraryIcon,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import React from 'react';
import { PALETTE_HEADER_OFFSET } from './blockPaletteConstants';
import PaletteEdgeTab from './PaletteEdgeTab';

interface BlockPaletteEdgeTabsProps {
  isNarrow: boolean;
  leftOffset: number;
  zIndex: number;
  onOpenBlocks: () => void;
  onOpenMedia: () => void;
  onOpenDocuments: () => void;
}

/**
 * Collapsed edge tabs shown when the palette drawer is closed, stacked in one
 * flex column so the gap between them is exact (not three independently
 * positioned boxes whose arithmetic has to be kept in sync by hand). On
 * desktop the stack starts at the same offset the open drawer uses
 * (PALETTE_HEADER_OFFSET), so "Content" lands exactly where the drawer's own
 * top would be. On narrow viewports it's anchored to the bottom instead,
 * built bottom-up via column-reverse so "Content" still ends up nearest the
 * anchor, same as before.
 */
export default function BlockPaletteEdgeTabs({
  isNarrow,
  leftOffset,
  zIndex,
  onOpenBlocks,
  onOpenMedia,
  onOpenDocuments,
}: BlockPaletteEdgeTabsProps) {
  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex,
        display: 'flex',
        ...(isNarrow
          ? { left: 16, bottom: 16, flexDirection: 'column-reverse', gap: '16px' }
          : {
              left: leftOffset,
              top: PALETTE_HEADER_OFFSET,
              flexDirection: 'column',
              gap: '10px',
            }),
      }}
    >
      <PaletteEdgeTab
        label="CONTENT"
        ariaLabel="Open block palette"
        icon={<AddIcon fontSize="small" />}
        isNarrow={isNarrow}
        onOpen={onOpenBlocks}
      />
      <PaletteEdgeTab
        label="MEDIA"
        ariaLabel="Open media library"
        icon={<VideoLibraryIcon fontSize="small" />}
        isNarrow={isNarrow}
        onOpen={onOpenMedia}
      />
      <PaletteEdgeTab
        label="DOCS"
        ariaLabel="Open document library"
        icon={<DescriptionIcon fontSize="small" />}
        isNarrow={isNarrow}
        onOpen={onOpenDocuments}
      />
    </Box>
  );
}
